import { isBooleanFalse, isBooleanTrue, isListNotEmpty, isNotNullOrUndefined, isNumberNotEmpty, isObjectNotEmpty, isStringNotEmpty, isStringNotEmptyOrZeroLength } from "../utils/objectUtils";
import { create, createWithId, getAll, getById, getBySingleQuery, remove, update, updateField, updateFields } from '../utils/dbUtils';
import { collection, endBefore, getCountFromServer, getDocs, limit, limitToLast, orderBy, query, startAfter, where } from 'firebase/firestore';
import { db } from '../firebase';
import { asTimeZone } from "../utils/dateFormatter";
import moment from 'moment-timezone';
import { toLower } from "lodash";
import logger from "../utils/logger";
import { getTestModeConsole } from "../utils/testMode";

class SiteVisit {
    static collectionName = 'siteVisits';

    offerId = null;
    affId = null;
    sub1 = null;
    sub2 = null;
    sub3 = null;
    sub4 = null;
    sub5 = null;
    uId = null;
    sourceId = null;
    transactionId = null;
    source = null;
    affiliateId = null;
    subAffiliateId = null;
    campaignId = null;
    programId = null;
    version = null;
    creativeId = null;
    clickId = null;
    ipAddress = null;
    userAgent = null;
    referrerUrl = null;
    // the rrx_visitor_id cookie, which outlives any single visit and links a visitor's sessions
    visitorId = null;
    // the marketing alias of the page the visit landed on - url keeps the real path
    landingRouteAlias = null;
    // server-owned: returns after 30 minutes away, and when the visitor was last seen
    returnCount = null;
    lastActiveAt = null;
    staffUserIds = null;
    userId = null;
    leadId = null;

    shippingState = null;
    gender = null;
    dateOfBirth = null;
    bmi = 0;

    conversionId = null;
    isConversion = false;

    couponCode = null;

    testMode = false;

    url = null;

    fbclid = null;
    fbc = null;
    ttclid = null;
    gclid = null;
    irclickid = null;
    rdt_cid = null;
    SsCid = null;
    msclkid = null;
    twclid = null;
    nbclid = null;
    gbraid = null;
    wbraid = null;

    utm_source = null;
    utm_campaign = null;
    utm_content = null;
    utm_medium = null;
    utm_term = null;

    productSku = null;
    offerGroupId = null;
    offerToken = null;
    addon = false;
    deviceFingerprint = null;

    constructor(siteVisit) {
        if (isObjectNotEmpty(siteVisit)) {
            if (isStringNotEmpty(siteVisit.offerId)) { this.offerId = siteVisit.offerId; }
            if (isStringNotEmpty(siteVisit.affId)) { this.affId = siteVisit.affId; }
            if (isStringNotEmpty(siteVisit.sub1)) { this.sub1 = siteVisit.sub1; }
            if (isStringNotEmpty(siteVisit.sub2)) { this.sub2 = siteVisit.sub2; }
            if (isStringNotEmpty(siteVisit.sub3)) { this.sub3 = siteVisit.sub3; }
            if (isStringNotEmpty(siteVisit.sub4)) { this.sub4 = siteVisit.sub4; }
            if (isStringNotEmpty(siteVisit.sub5)) { this.sub5 = siteVisit.sub5; }
            if (isStringNotEmpty(siteVisit.uId)) { this.uId = siteVisit.uId; }
            if (isStringNotEmpty(siteVisit.sourceId)) { this.sourceId = siteVisit.sourceId; }
            if (isStringNotEmpty(siteVisit.transactionId)) { this.transactionId = siteVisit.transactionId; }
            if (isStringNotEmpty(siteVisit.source)) { this.source = siteVisit.source; }
            if (isStringNotEmpty(siteVisit.affiliateId)) { this.affiliateId = toLower(siteVisit.affiliateId); }
            if (isStringNotEmpty(siteVisit.subAffiliateId)) { this.subAffiliateId = toLower(siteVisit.subAffiliateId); }
            if (isStringNotEmpty(siteVisit.campaignId)) { this.campaignId = siteVisit.campaignId; }
            if (isStringNotEmpty(siteVisit.programId)) { this.programId = siteVisit.programId; }
            if (isStringNotEmpty(siteVisit.version)) { this.version = toLower(siteVisit.version); }
            if (isStringNotEmpty(siteVisit.creativeId)) { this.creativeId = toLower(siteVisit.creativeId); }
            if (isStringNotEmpty(siteVisit.clickId)) { this.clickId = siteVisit.clickId; }
            if (isStringNotEmpty(siteVisit.ipAddress)) { this.ipAddress = siteVisit.ipAddress; }
            if (isStringNotEmpty(siteVisit.userAgent)) { this.userAgent = siteVisit.userAgent; }
            if (isStringNotEmpty(siteVisit.referrerUrl)) { this.referrerUrl = siteVisit.referrerUrl; }
            if (isStringNotEmpty(siteVisit.visitorId)) { this.visitorId = siteVisit.visitorId; }
            if (isStringNotEmpty(siteVisit.landingRouteAlias)) { this.landingRouteAlias = siteVisit.landingRouteAlias; }
            if (isNumberNotEmpty(siteVisit.returnCount)) { this.returnCount = siteVisit.returnCount; }
            if (isNotNullOrUndefined(siteVisit.lastActiveAt)) { this.lastActiveAt = siteVisit.lastActiveAt; }
            if (isListNotEmpty(siteVisit.staffUserIds)) { this.staffUserIds = siteVisit.staffUserIds; }
            if (isStringNotEmpty(siteVisit.userId)) { this.userId = siteVisit.userId; }
            if (isStringNotEmpty(siteVisit.leadId)) { this.leadId = siteVisit.leadId; }

            if (isStringNotEmpty(siteVisit.shippingState)) { this.shippingState = siteVisit.shippingState; }
            if (isStringNotEmpty(siteVisit.gender)) { this.gender = siteVisit.gender; }
            if (isStringNotEmpty(siteVisit.dateOfBirth)) { this.dateOfBirth = siteVisit.dateOfBirth; }
            if (isNumberNotEmpty(siteVisit.bmi)) { this.bmi = siteVisit.bmi; }

            if (isStringNotEmpty(siteVisit.conversionId)) { this.conversionId = siteVisit.conversionId; }
            if (isBooleanTrue(siteVisit.isConversion)) { this.isConversion = true; }

            if (isStringNotEmpty(siteVisit.couponCode)) { this.couponCode = siteVisit.couponCode; }

            if (isBooleanTrue(siteVisit.testMode)) { this.testMode = true; }

            if (isStringNotEmpty(siteVisit.url)) { this.url = siteVisit.url; }

            if (isStringNotEmpty(siteVisit.fbclid)) { this.fbclid = siteVisit.fbclid; }
            if (isStringNotEmpty(siteVisit.fbc)) { this.fbc = siteVisit.fbc; }
            if (isStringNotEmpty(siteVisit.ttclid)) { this.ttclid = siteVisit.ttclid; }
            if (isStringNotEmpty(siteVisit.gclid)) { this.gclid = siteVisit.gclid; }
            if (isStringNotEmpty(siteVisit.irclickid)) { this.irclickid = siteVisit.irclickid; }
            if (isStringNotEmpty(siteVisit.rdt_cid)) { this.rdt_cid = siteVisit.rdt_cid; }
            if (isStringNotEmpty(siteVisit.SsCid)) { this.SsCid = siteVisit.SsCid; }
            if (isStringNotEmpty(siteVisit.msclkid)) { this.msclkid = siteVisit.msclkid; }
            if (isStringNotEmpty(siteVisit.twclid)) { this.twclid = siteVisit.twclid; }
            if (isStringNotEmpty(siteVisit.nbclid)) { this.nbclid = siteVisit.nbclid; }
            if (isStringNotEmpty(siteVisit.gbraid)) { this.gbraid = siteVisit.gbraid; }
            if (isStringNotEmpty(siteVisit.wbraid)) { this.wbraid = siteVisit.wbraid; }

            if (isStringNotEmpty(siteVisit.utm_source)) { this.utm_source = siteVisit.utm_source; }
            if (isStringNotEmpty(siteVisit.utm_campaign)) { this.utm_campaign = siteVisit.utm_campaign; }
            if (isStringNotEmpty(siteVisit.utm_content)) { this.utm_content = siteVisit.utm_content; }
            if (isStringNotEmpty(siteVisit.utm_medium)) { this.utm_medium = siteVisit.utm_medium; }
            if (isStringNotEmpty(siteVisit.utm_term)) { this.utm_term = siteVisit.utm_term; }

            if (isStringNotEmpty(siteVisit.productSku)) { this.productSku = siteVisit.productSku; }
            if (isStringNotEmpty(siteVisit.offerGroupId)) { this.offerGroupId = siteVisit.offerGroupId; }
            if (isStringNotEmpty(siteVisit.offerToken)) { this.offerToken = siteVisit.offerToken; }
            if (isBooleanTrue(siteVisit.addon)) { this.addon = true; }
            if (isStringNotEmpty(siteVisit.deviceFingerprint)) { this.deviceFingerprint = siteVisit.deviceFingerprint; }
        }
    }

    toDto = () => {
        return {
            offerId: this.offerId,
            affId: this.affId,
            sub1: this.sub1,
            sub2: this.sub2,
            sub3: this.sub3,
            sub4: this.sub4,
            sub5: this.sub5,
            uId: this.uId,
            sourceId: this.sourceId,
            transactionId: this.transactionId,
            source: this.source,
            affiliateId: this.affiliateId,
            subAffiliateId: this.subAffiliateId,
            campaignId: this.campaignId,
            programId: this.programId,
            version: this.version,
            creativeId: this.creativeId,
            clickId: this.clickId,
            ipAddress: this.ipAddress,
            userAgent: this.userAgent,
            referrerUrl: this.referrerUrl,
            visitorId: this.visitorId,
            landingRouteAlias: this.landingRouteAlias,
            returnCount: this.returnCount,
            lastActiveAt: this.lastActiveAt,
            staffUserIds: this.staffUserIds,
            userId: this.userId,
            leadId: this.leadId,

            shippingState: this.shippingState,
            gender: this.gender,
            dateOfBirth: this.dateOfBirth,
            bmi: this.bmi,

            conversionId: this.conversionId,
            isConversion: this.isConversion,

            couponCode: this.couponCode,

            testMode: this.testMode,

            url: this.url,

            fbclid: this.fbclid,
            fbc: this.fbc,
            ttclid: this.ttclid,
            gclid: this.gclid,
            irclickid: this.irclickid,
            rdt_cid: this.rdt_cid,
            SsCid: this.SsCid,
            msclkid: this.msclkid,
            twclid: this.twclid,
            nbclid: this.nbclid,
            gbraid: this.gbraid,
            wbraid: this.wbraid,

            utm_source: this.utm_source,
            utm_campaign: this.utm_campaign,
            utm_content: this.utm_content,
            utm_medium: this.utm_medium,
            utm_term: this.utm_term,

            productSku: this.productSku,
            offerGroupId: this.offerGroupId,
            offerToken: this.offerToken,
            addon: this.addon,
            deviceFingerprint: this.deviceFingerprint
        };
    }

    create = async () => {
        // the landing pageview/impression SiteEvents are emitted by TrackingService.createSiteVisit
        // so both create paths produce the same event set - do not add event side effects back here
        return await create(SiteVisit.collectionName, this.toDto());
    }

    // idempotent create-if-absent: the API handler and this fallback target the same client-
    // generated id, and an id that already exists returns the existing document unchanged
    createWithId = async (id) => {
        if (isStringNotEmpty(id)) {
            return await createWithId(SiteVisit.collectionName, id, this.toDto());
        } else {
            throw new Error("id is required.");
        }
    }

    static updateField = async (id, fieldName, newValue) => {
        if (isStringNotEmpty(id)) {
            return await updateField(SiteVisit.collectionName, id, fieldName, newValue);
        } else {
            throw new Error("id is required.");
        }
    }

    static updateFields = async (id, updatedFields) => {
        if (isStringNotEmpty(id)) {
            return await updateFields(SiteVisit.collectionName, id, updatedFields);
        } else {
            throw new Error("id is required.");
        }
    }

    static update = async (id, updatedSiteVisit) => {
        const updatedObj = new SiteVisit(updatedSiteVisit);
        if (id === updatedSiteVisit.id) {
            return await update(SiteVisit.collectionName, id, updatedObj.toDto());
        } else {
            throw new Error('id and id field of the updated site visit must match.')
        }
    }

    static delete = async (id) => {
        if (isStringNotEmpty(id)) {
            return await remove(SiteVisit.collectionName, id);
        } else {
            throw new Error("id is required.");
        }
    }

    static getById = async (id) => {
        return await getById(SiteVisit.collectionName, id);
    }

    static getAll = async () => {
        return await getAll(SiteVisit.collectionName);
    }

    static getByField = async (fieldName, fieldValue, comparer = '==') => {
        return await getBySingleQuery(SiteVisit.collectionName, fieldName, fieldValue, comparer);
    }

    static getByLeadId = async (leadId) => {
        const list = await getBySingleQuery(SiteVisit.collectionName, 'leadId', leadId, '==');
        if (isListNotEmpty(list)) {
            return list[0];
        }

        return null;
    }

    static getCount = async (queryParameters) => {
        const { affiliateId, subAffiliateId, start, end, testMode } = queryParameters;

        let queryConstraints = [];

        if (isListNotEmpty(affiliateId)) {
            queryConstraints.push(where('affiliateId', 'in', toLower(affiliateId)));
        } else if (isStringNotEmptyOrZeroLength(affiliateId)) {
            queryConstraints.push(where('affiliateId', '==', toLower(affiliateId)));
        }

        if (isListNotEmpty(subAffiliateId)) {
            queryConstraints.push(where('subAffiliateId', 'in', subAffiliateId));
        } else if (isStringNotEmptyOrZeroLength(subAffiliateId)) {
            queryConstraints.push(where('subAffiliateId', '==', subAffiliateId));
        }

        if (isBooleanTrue(testMode)) {
            queryConstraints.push(where('testMode', '==', true));
        } else if (isBooleanFalse(testMode)) {
            queryConstraints.push(where('testMode', '==', false));
        }

        if (isNotNullOrUndefined(start)) {
            let startDate = asTimeZone(moment(new Date(start)), 'US/Pacific').startOf('day').utc().toDate();
            queryConstraints.push(where('createdAt', '>=', startDate));
        }

        if (isNotNullOrUndefined(end)) {
            let endDate = asTimeZone(moment(new Date(end)), 'US/Pacific').endOf('day').utc().toDate();
            queryConstraints.push(where('createdAt', '<=', endDate));
        }

        let q = query(collection(db, SiteVisit.collectionName), ...queryConstraints);

        const snapShot = await getCountFromServer(q);

        //console.log(snapShot.data());

        return snapShot.data().count;
    }

    static getPaginated = async (queryParameters, pageSize = 25, firstVisible, lastVisible, orderByField = 'createdAt') => {
        const { affiliateId, subAffiliateId, start, end, testMode } = queryParameters;

        let queryConstraints = [];

        if (isListNotEmpty(affiliateId)) {
            queryConstraints.push(where('affiliateId', 'in', toLower(affiliateId)));
        } else if (isStringNotEmptyOrZeroLength(affiliateId)) {
            queryConstraints.push(where('affiliateId', '==', toLower(affiliateId)));
        }

        if (isListNotEmpty(subAffiliateId)) {
            queryConstraints.push(where('subAffiliateId', 'in', subAffiliateId));
        } else if (isStringNotEmptyOrZeroLength(subAffiliateId)) {
            queryConstraints.push(where('subAffiliateId', '==', subAffiliateId));
        }

        if (isBooleanTrue(testMode)) {
            queryConstraints.push(where('testMode', '==', true));
        } else if (isBooleanFalse(testMode)) {
            queryConstraints.push(where('testMode', '==', false));
        }

        if (isNotNullOrUndefined(start)) {
            let startDate = asTimeZone(moment(new Date(start)), 'US/Pacific').startOf('day').utc().toDate();
            queryConstraints.push(where('createdAt', '>=', startDate));
        }

        if (isNotNullOrUndefined(end)) {
            let endDate = asTimeZone(moment(new Date(end)), 'US/Pacific').endOf('day').utc().toDate();
            queryConstraints.push(where('createdAt', '<=', endDate));
        }

        let q = null;
        if (isObjectNotEmpty(firstVisible)) {
            q = query(collection(db, SiteVisit.collectionName), ...queryConstraints, orderBy(orderByField, 'asc'), orderBy('__name__', 'asc'), limitToLast(pageSize), endBefore(firstVisible[orderByField], firstVisible['id']));
        } else if (isObjectNotEmpty(lastVisible)) {
            q = query(collection(db, SiteVisit.collectionName), ...queryConstraints, orderBy(orderByField, 'asc'), orderBy('__name__', 'asc'), limit(pageSize), startAfter(lastVisible[orderByField], lastVisible['id']));
        } else {
            q = query(collection(db, SiteVisit.collectionName), ...queryConstraints, orderBy(orderByField, 'asc'), orderBy('__name__', 'asc'), limit(pageSize));
        }

        let snapShot = await getDocs(q);
        return snapShot.docs.map((doc) => {
            return {
                id: doc.id,
                ...doc.data()
            };
        });
    }

    static get = async (queryParameters) => {
        // console.log('queryParameters', queryParameters);
        let allRecords = [];
        try {
            let next = null;
            let totalPages = 0;

            let totalCount = await this.getCount(queryParameters);
            totalPages = Math.ceil(totalCount / 10000.0);
            // console.log('totalCount: ' + totalCount);
            // console.log('totalPages: ' + totalPages);
            let pages = [];
            for (let i = 0; i < totalPages; i++) {
                pages.push(i + 1);
            }
            for (const page of pages) {
                // console.log('starting page ' + page);

                let list = await this.getPaginated(queryParameters, 10000, null, next, 'createdAt');

                // console.log(list.length);
                allRecords = [...allRecords, ...list];

                // console.log(allRecords.length);

                // console.log('go to next page');
                next = list[list.length - 1];
            }
        } catch (error) {
            logger.logErrorEvent('SITE_VISIT_PAGINATED', error, 'Error paginating site visits', getTestModeConsole());
        }

        return allRecords;
    }
};

export default SiteVisit;
